
export default function Facebook() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3164_1042)">
        <path d="M19.2732 10.0232C19.2732 4.90439 15.1188 0.75 9.99998 0.75C4.88119 0.75 0.726807 4.90439 0.726807 10.0232C0.726807 14.5114 3.91678 18.2485 8.14534 19.1109V12.8051H6.29072V10.0232H8.14534V7.70489C8.14534 5.91516 9.60123 4.45927 11.391 4.45927H13.7093V7.24123H11.8546C11.3446 7.24123 10.9273 7.65852 10.9273 8.16855V10.0232H13.7093V12.8051H10.9273V19.25C15.6103 18.7863 19.2732 14.836 19.2732 10.0232Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_3164_1042">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}
